<template>
  <!-- container -->
  <div id="middleWrapM" class="container">
    <!-- sub title -->
    <div class="sub_tit_area tech02">
      <img
        :src="`${resources}img/img-top-sub-title2.jpg`"
        alt=""
        v-if="device === 'mo'"
      />
      <div class="tit_area">
        <div class="sub_tit">건축사업</div>
        <div class="sub_txt" v-if="device === 'mo'">
          고객에게 최상의 가치를 실현해 드립니다.
        </div>
        <div class="sub_txt" v-else>
          한국오션플랫폼은 건축에 대한 오랜 경험과 노하우를 가진 전문가 집단이
          모여 올바른 생각과 철학을 가지고 <br />
          고객의 필요와 요구를 반영한 최적의 공간을 건설합니다.
        </div>
      </div>
    </div>
    <!--// sub title -->

    <!-- sub contents -->
    <div class="sub_contents">
      <ul class="factory_info3" v-if="device === 'mo'">
        <li class="div_color01">
          <p class="txt_step">STEP 01</p>
          <p class="tit_info3"><strong>계획</strong> Planning</p>
          <ul>
            <li>사업 구상</li>
            <li>사업타당성 분석</li>
            <li>기본계획 수립</li>
          </ul>
          <div>
            오랜 경험과 노하우를 기반으로 <br />건축 전반에 대한 컨설팅을
            진행합니다.
          </div>
        </li>
        <li class="div_color02">
          <p class="txt_step">STEP 02</p>
          <p class="tit_info3"><strong>설계</strong> Design</p>
          <ul>
            <li>설계 VE</li>
            <li>3D 시뮬레이션</li>
            <li>시공계획 수립</li>
          </ul>
          <div>
            고객의 라이프스타일을 고려한 개성 있고 <br />차별화된 공간 설계와
            디자인을 제안합니다.
          </div>
        </li>
        <li class="div_color03">
          <p class="txt_step">STEP 03</p>
          <p class="tit_info3"><strong>공사</strong> Construction</p>
          <ul>
            <li>시공 및 공사관리</li>
            <li>예비준공검사</li>
            <li>준공</li>
          </ul>
          <div>
            철저한 품질관리, 일정관리를 통한 <br />정밀 시공을 실현합니다.
          </div>
        </li>
      </ul>
      <div class="sub_cont_txt" v-else>
        <img
          :src="`${resources}img/img_tech01_1-1.png`"
          alt="step 01.계획 Planning:(-사업 구상 -사업타당성 분석 -기본계획수립) 오랜 경험과 노하우를 기반으로 건축 전반에 대한 컨설팅을 진행합니다.step 02.설계 Design:(-설계 VE-3D 시뮬레이션 -시공계획수립)고객의의 라이프스타일을 고려한 개성있고 차별화된 공간설계와 디자인을 제안합니다. step 03.공사 Construction:(-시공 및 공사관리 -예비준공검사 -준공)철저한 품질관리, 일정관리를 통해 안전하고 신뢰할 수 있는 정밀 시공을 실현합니다."
        />
      </div>
      <div
        class="tbl_ty01 bod align_td_cnt mgt40 tbl_scroll"
        v-if="device === 'mo'"
      >
        <table>
          <caption>
            건축사업
          </caption>
          <colgroup>
            <col style="width: 25%" />
            <col style="width: 35%" />
            <col style="width: 20%" />
            <col style="width: 20%" />
          </colgroup>
          <thead>
            <th scope="row">발주처</th>
            <th scope="row">현장명</th>
            <th scope="row">연 도</th>
            <th scope="row">시공실적<br />(단위:억원)</th>
          </thead>
          <tbody>
            <tr>
              <td>㈜로지필드</td>
              <td>양산복합물류센터</td>
              <td>2021</td>
              <td>171</td>
            </tr>
            <tr>
              <td>강북구청</td>
              <td>삼양동공영주차장 리모델링공사</td>
              <td>2020</td>
              <td>5.8</td>
            </tr>
            <tr>
              <td>LS ELECTRIC</td>
              <td>영암태양광발전시설</td>
              <td>2019</td>
              <td>67</td>
            </tr>
            <tr>
              <td>예스코</td>
              <td>경기지사 남양주호평</td>
              <td>2012</td>
              <td>33</td>
            </tr>
            <tr>
              <td>유유물류산업㈜</td>
              <td>유유물류센터</td>
              <td>2012</td>
              <td>736</td>
            </tr>
            <tr>
              <td>SIG개발</td>
              <td>화도물류센터</td>
              <td>2012</td>
              <td>461</td>
            </tr>
            <tr>
              <td>케이씨 플레닝</td>
              <td>까치산 오거닉스</td>
              <td>2008</td>
              <td>50</td>
            </tr>
            <tr>
              <td>대화화장품</td>
              <td>신길동 오거닉스</td>
              <td>2007</td>
              <td>31</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="tbl_ty01 bod align_td_cnt mgt80" v-else>
        <table>
          <caption>
            건축사업
          </caption>
          <colgroup>
            <col style="width: 25%" />
            <col style="width: 35%" />
            <col style="width: 20%" />
            <col style="width: 20%" />
          </colgroup>
          <thead>
            <th scope="row">발주처</th>
            <th scope="row">현장명</th>
            <th scope="row">연 도</th>
            <th scope="row">시공실적 (단위:억원)</th>
          </thead>
          <tbody>
            <tr>
              <td>㈜로지필드</td>
              <td>양산복합물류센터</td>
              <td>2021</td>
              <td>171</td>
            </tr>
            <tr>
              <td>강북구청</td>
              <td>삼양동공영주차장 리모델링공사</td>
              <td>2020</td>
              <td>5.8</td>
            </tr>
            <tr>
              <td>LS ELECTRIC</td>
              <td>영암태양광발전시설</td>
              <td>2019</td>
              <td>67</td>
            </tr>
            <tr>
              <td>예스코</td>
              <td>경기지사 남양주호평</td>
              <td>2012</td>
              <td>33</td>
            </tr>
            <tr>
              <td>유유물류산업㈜</td>
              <td>유유물류센터</td>
              <td>2012</td>
              <td>736</td>
            </tr>
            <tr>
              <td>SIG개발</td>
              <td>화도물류센터</td>
              <td>2012</td>
              <td>461</td>
            </tr>
            <tr>
              <td>케이씨 플레닝</td>
              <td>까치산 오거닉스</td>
              <td>2008</td>
              <td>50</td>
            </tr>
            <tr>
              <td>대화화장품</td>
              <td>신길동 오거닉스</td>
              <td>2007</td>
              <td>31</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!--// sub contents -->
  </div>
  <!--// container -->
</template>

<script>
import page from '@/mixins/page';

export default {
  mixins: [page]
};
</script>

<style lang="scss" scoped></style>
